<template lang="pug">
  .joruneys-wrapper
    RadioSlider.slider(
      :items="optionsData.items",
      :current="optionsData.items.findIndex(i => i.id === optionsData.selected.id)",
      @selected="onSelectOption"
    )

    template(v-if="optionsData.selected.id === 'journey'")
      JourneyPicker(@selectJourney="onSelectJourney" :showCloseButton="false"
        :selectedJourneyId="selectedJourney ? selectedJourney.id : null")

      PCheckbox(label="ignorar dias de jornada sem trabalho", v-model="ignoreFolga")

    template(v-if="optionsData.selected.id === 'vacation'")
      PDatePicker(
        name="date"
        label="selecionar período"
        v-model="period"
        :range="true"
      )

    PButton(size="md" block color="success" @click="save" :loading="saving") Salvar

</template>

<script>
import JourneyPicker from 'src/common/JourneyPicker'
import {formatDateToSend} from 'src/utils'

export default {
  name: 'Journeys',
  components: {JourneyPicker},
  props: {
    saveParams: {type: Object, required: true},
    options: {type: Array, required: true}
  },
  created () {
    this.optionsData.items = this.options
    this.optionsData.selected = this.options[0]
  },
  data () {
    return {
      saving: false,
      selectedJourney: null,
      optionsData: {
        selected: null,
        items: []
      },
      period: {
        start: new Date(),
        end: new Date()
      },
      ignoreFolga: false
    }
  },
  methods: {
    async save () {
      this.saving = true

      const params = {
        companies: this.saveParams.companies,
        employees: this.saveParams.employees,
        employer: this.saveParams.employer
      }

      if (this.optionsData.selected.id === 'vacation') {
        params.startDate = formatDateToSend(this.period.start)
        params.endDate = formatDateToSend(this.period.end)
      } else {
        params.startDate = this.saveParams.startDate
        params.endDate = this.saveParams.endDate
      }

      try {
        const result = await this.$API.fastRegister.save({
          ...params,
          option: this.optionsData.selected.id,
          extra: this.optionsData.selected.id === 'journey'
            ? {
              journey: this.selectedJourney,
              ignore_folga: this.ignoreFolga
            }
            : {}
        })
        this.$checkUserFiles()
        this.$swal({
          type: 'success',
          text: result.data?.success ? result.data.success : 'Mudanças aplicadas com sucesso'
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possivel aplicar as mudanças'
        })
      }

      this.saving = false
    },
    onSelectOption (item) {
      this.optionsData.selected = item
    },
    onSelectJourney (journey) {
      this.selectedJourney = journey
    }
  }
}
</script>

<style scoped lang="scss">
.joruneys-wrapper {
  display: grid;
  grid-row-gap: 30px;

  h3 {
    align-self: center;
    text-align: center;
  }
}
</style>
